import axios from "axios";

const customAxios = axios.create({
  // baseURL: "http://localhost:8080",
  // baseURL: "https://vms-backend-xu8l.onrender.com",
  // baseURL: "https://vmsbackend.comdata.in",
  baseURL: "http://mahapolicevmsbackend.comdata.in/",
});

export default customAxios;


